import HeaderTags from 'app/shared-components/helmet/HeaderTags';
import generateUserSchema from 'app/shared-components/helmet/generateUserSchema';
import generateOrgSchema from 'app/shared-components/helmet/generateOrgSchema';

const ArticleHeaderTags = ({ title, description, userAuthor, organizationAuthor, image, datePublished, keywords, article }) => {
  const publisher = "Halespring";
  const host = window.location.protocol + '//' + window.location.host;
  const publisherLogo = host + '/assets/images/logo/HALESPRING-LOGO-ONLY-1500.png'
  const useType = 'article';
  
  // Use slug-based URL if available, otherwise use current URL
  const canonicalUrl = article?.slug 
    ? `${host}/article/${article.slug}`
    : host + window.location.pathname;
  
  if (!userAuthor && !organizationAuthor) {
    return <HeaderTags title={title} description={description} keywords={keywords} type={useType} image={image} />;
  }
  
  const authorSchema = userAuthor 
    ? generateUserSchema({ user: userAuthor, includeContext: false })
    : generateOrgSchema({ organization: organizationAuthor, includeContext: false });
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": canonicalUrl,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": canonicalUrl
    },
    "headline": title,
    "description": description,
    "image": image,  
    "author": authorSchema,
    "publisher": {
      "@type": "Organization",
      "name": publisher,
      "logo": {
        "@type": "ImageObject",
        "url": publisherLogo
      }
    },
    "datePublished": datePublished
  };

  return (
    <HeaderTags title={title} description={description} keywords={keywords} type={useType} image={image} schema={schema} />
  );
};

export default ArticleHeaderTags;